module.exports = __webpack_public_path__ + "static/img/contact.2ce9233.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hero/contact.jpg
// module id = b+92
// module chunks = 1